//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('visitor', {
//        templateUrl: 'views/components/views/visitor/visitor.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['utilityService', 'visitorService', function (utilityService, visitorService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                bgVisited: {
//                    selected: 'IN',
//                    buttons: [
//                        { id: 'IN', label: 'in', color: 'primary', onClick: function () { vm.model.bgVisited.selected = 'IN'; } },
//                        { id: 'OUT', label: 'out', color: 'primary', onClick: function () { vm.model.bgVisited.selected = 'OUT'; } }
//                    ]
//                },
//                personNameButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('pers_name') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => vm.searchItems() }
//                ], 
//                setting: {
//                    pers_name: '',
//                    inout: 'IN'
//                },
//                itemsListPersons: [],
//                itemsListCheckOut: [],
//                searchingFromBtn: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadFindPersons() {
//                if (utilityService.validateParmsValue(vm.model.setting.pers_name) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.inout) !== true) return;
                
//                return visitorService.listFindPersons({
//                    pers_name: vm.model.setting.pers_name,
//                    inout: vm.model.setting.inout
//                }).then(function (list) {
//                    vm.model.searchingFromBtn = false;
//                    vm.model.itemsListPersons = list;
//                });
//            }
            
//            async function loadVisitorOuts() {
//                if (utilityService.validateParmsValue(vm.model.setting.inout) !== true) return;
                
//                return vm.model.itemsListCheckOut = await visitorService.listVisitorOuts({ inout: vm.model.setting.inout });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region CLEAR MULTI FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'pers_name':
//                        vm.model.setting.pers_name = '';
//                        vm.model.itemsListPersons = [];
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion CLEAR MULTI FUNCTION

//            // #region SELECT BUTTON RADIO FUNCTION

//            vm.selectBgVisited = function (value) {
//                vm.model.bgVisited.selected = value;
//                vm.model.setting.inout = vm.model.bgVisited.selected;

//                if (vm.model.setting.inout === 'OUT') loadVisitorOuts();
//            }

//            // #endregion SELECT BUTTON RADIO FUNCTION

//            // #region ENTER & SEARCH FUNCTION

//            vm.searchItems = function () {
//                if (vm.model.setting.inout === 'IN') {
//                    if (vm.model.setting.pers_name.length > 3) loadFindPersons();
//                }
//            }

//            // #endregion ENTER & SEARCH FUNCTION

//            // #region SEARCH BUTTON FUNCTION

//            vm.searchBtn = function () {
//                if (vm.model.setting.inout === 'IN') {
//                    if (vm.model.setting.pers_name.length > 3) {
//                        vm.model.searchingFromBtn = true;
//                        loadFindPersons();
//                    }
//                }
//            }

//            // #endregion SEARCH BUTTON FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'pers_name':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.pers_name) !== true) return;

//                        vm.model.setting.pers_name = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.pers_name, true) !== true) return;

//                        if (vm.model.setting.inout === 'IN') {
//                            if (vm.model.setting.pers_name === '') {
//                                vm.model.itemsListPersons = [];
//                            }
//                        }
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//        }]
//    });
//})();
